module.exports = __webpack_public_path__ + "bd58eccc7c727e82e34c2c15356f437c.png";